module.exports = __webpack_public_path__ + "static/img/2023年历-1.d7198e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2023年历-1.jpg
// module id = G+JW
// module chunks = 3